module.exports = require("core-js-pure/features/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/object/set-prototype-of.js
// module id = 2127
// module chunks = 25